import React, { useEffect, useState } from 'react'
import { Form, DatePicker, Select, Row, Col, Transfer, Tooltip, Modal, message, Card } from 'antd';
import Input from '../../../ui/Input';
import TextArea from '../../../ui/TextArea';
import ActionButtonsBar from '../../../ui/ActionButtonsBar';
import { SearchOutlined } from '@ant-design/icons';
import { LocalPersistence } from '../../../../factories';
import { deleteAttraction, updateAttraction } from '../../../../services/attraction'
import Loading from '../../../Loading';
import moment from 'moment';
import styles from './../../index.module.css';
import PageContainer from '../../../CSIComponents/PageContainer';
import { PROXIMITY_OPTIONS } from '@constants/index'
import { isTagsDisplayed } from '@helpers/FeatureFlags'

const Option = Select.Option;
const dateFormat = 'MM/DD/YYYY';
const AttractionDetailEdit = (props: { setTransferData:any,transferData:any,typeLayData:any,typeAccData:any,setCurrentFlag: any,currentLine:any,currentFlag:any, setCurrentLine:any }) => {
    const [form] = Form.useForm()
    const [transferTargetKeys, setTransferTargetKeys] = useState<Array<any>>([])
    const [editLoading, setEditLoading] = useState(false)
    const [data,setData] = useState<Array<any>>([])
    const [disabledStatus, setDisabledStatus] = useState<boolean>(false)
    const [typeData, setTypeData] = useState<Array<any>>([])

    useEffect(() => {
        getChangeTypeData()
        setData(props.transferData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (props.currentLine) {
            if (props.currentLine.startdate) {
                props.currentLine.startAndEndDate = [moment(props.currentLine.startdate,dateFormat),moment(props.currentLine.enddate,dateFormat)]
            } else {
                props.currentLine.startAndEndDate = []
            }
            form.setFieldsValue({...props.currentLine, tags:''})
            props.currentLine.tags && props.currentLine.tags != '' ? setTransferTargetKeys(props.currentLine.tags.split(' | ')) : setTransferTargetKeys([])
        } else {
            form.resetFields()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.currentLine])
    
    const handleChange = (targetKeys:any) => {
        setTransferTargetKeys(targetKeys)
    };
    const changeTypeData = (value: any)=> {
        form.setFields([{
            name: 'type',
            value: ''
          }])
        if (value === 'Open Travel Standard') {
            setTypeData(props.typeAccData)
        } else if (value === 'Lanyon Attraction Type') {
            setTypeData(props.typeLayData)
        }
    }
    const getChangeTypeData = ()=> {
        if (props.currentLine.typestandard === 'Open Travel Standard') {
            setTypeData(props.typeAccData)
        } else if (props.currentLine.typestandard === 'Lanyon Attraction Type') {
            setTypeData(props.typeLayData)
        }
    }

    const saveFun = async (value:any)=>{
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        value.tags = transferTargetKeys.length!=0?transferTargetKeys.join(' | ') : ''
        value.startdate = value.startAndEndDate && value.startAndEndDate.length > 0 ? moment(value.startAndEndDate[0]).format(dateFormat) : ''
        value.enddate = value.startAndEndDate && value.startAndEndDate.length > 0 ? moment(value.startAndEndDate[1]).format(dateFormat) : ''
        value.attractionlangid = props.currentLine.attractionlangid 
        value.attractionid = props.currentLine.attractionid 
        const bodyQuery = {
            supplier: session.supplier,
            propertyId: session.propertyId,
            property: {
                attractions: [value]
            }
        }
        updateAttraction(bodyQuery).then(res => {
            if (res.result.success) {
                // let _currentLine = {
                //     id:value.id,
                //     name : value.name,
                //     url : value.url,
                //     desc : value.desc,
                //     typestandard : value.typestandard,
                //     type : value.type,
                //     proximity : value.proximity,
                //     typedetail : value.typedetail,
                //     rank : value.rank,
                //     season : value.season,
                //     guesttype : value.guesttype,
                //     startdate : value.startdate,
                //     enddate : value.enddate,
                //     tags : value.tags,
                //     crossstreet : value.crossstreet
                // }
                setEditLoading(false)
                props.setCurrentFlag('view')
                props.setCurrentLine({...props.currentLine, ...value})
            } else {
                setEditLoading(false)
                message.error({
                    content: res?.error[0]?.message || 'operation failed'
                });
            }
        }, err => {
            message.error({
                content: err?.message || err?.error[0]?.message
            });
            setEditLoading(false)
        })

    }

    // save
    const SaveClick = () => { 
        props.setCurrentFlag(null)       
        setEditLoading(true)
                    
        form.validateFields().then( value => {
            saveFun(value)
        }).catch(() => {
            setEditLoading(false)
            message.error({
                content: 'Check all the fields please.',
            });
        })
    }
    const ModalHead = () => {
        return (
            <div className={styles.modalHead}>Confirm</div>
        )
    }

    const DeleteClick = async() => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        Modal.confirm({
            title: <ModalHead />,
            centered: true,
            icon: '',
            content:`Are you sure you want to delete ${props.currentLine.name} ?`,            
            cancelText: 'Cancel',
            okText: 'Delete',
            onOk:  async() => {
                // deleteAttractions
                const bodyQuery = {
                    supplier: session.supplier,
                    propertyId: session.propertyId,
                    property: {
                        attractions:[
                            {
                               attractionid:props.currentLine.attractionid,
                               attractionlangid:props.currentLine.attractionlangid
                            }
                         ]
                    }
                }
                deleteAttraction(bodyQuery).then(res => {
                    if (res.result.success) {
                        props.setCurrentFlag('table')
                    } else {
                        message.error({
                            content: res?.error[0]?.message || 'operation failed'
                        });
                    }
                }, err => {
                    message.error({
                        content: err?.message || err?.error[0]?.message
                    });
                })
            },
            onCancel() {
                
            },
        });
        
    }
    

    const onSearchChange = (e:any) =>{
        let res = data.filter(item => item.codeName.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1)
        props.setTransferData(res)
    }
    const validateFieldsError = (changedValues: any, allValues: any) => {
        form.validateFields().then(() => {
          setDisabledStatus(false)
    
        }).catch(() => {
                let savelock = false
                let s = form?.getFieldsError()
                    for (let i = 0; i < s.length; i++) {
                    if(s[i].errors.length) {
                        savelock = true;
                        break
                    }
                }
                setDisabledStatus(savelock)
        })
      }
    const urlRegex: any = '^((https|http|ftp|rtsp|mms)?://)?(([0-9a-z]+: )?[0-9a-z_!~*\'().&=+$%-]+@)?(([0-9]{1,3}.){3}[0-9]{1,3}|([0-9a-z]+.)+([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].[a-z]{2,6})(:[0-9]{1,4})?((/?)|(/[0-9a-z]+)+/?)$';
    if (editLoading) return <Loading type='large' />
    
    return (
      <PageContainer>
        <Card style={{ marginTop: -15 }}>
          <div>
            <div className={styles.detailViewHead}>
              <div className={styles.detailViewName}>Attraction</div>
            </div>
            <div className={styles.detailInCon}>
              <Form
                layout='vertical'
                form={form}
                name='basic'
                onValuesChange={validateFieldsError}>
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      label='Name'
                      name='name'
                      rules={[
                        {
                          required: true,
                          message: 'This field is required',
                        },
                        {
                          max: 128,
                          message:
                            'You have reached the max character length of 128',
                        },
                      ]}>
                      <Input maxLength={128} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label='Attraction ID'
                      name='id'
                      rules={[
                        {
                          max: 32,
                          message:
                            'You have reached the max character length of 32',
                        },
                      ]}>
                      <Input maxLength={32} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label='Website URL'
                      name='url'
                      rules={[
                        {
                          pattern: urlRegex,
                          message: 'This field should be a URL',
                        },
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item
                      name='desc'
                      label='Description'
                      rules={[
                        {
                          max: 300,
                          message:
                            'You have reached the max character length of 300',
                        },
                      ]}>
                      <TextArea maxLength={300} />
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      label='Type Standard'
                      name='typestandard'
                      rules={[
                        {
                          required: true,
                          message: 'This field is required',
                        },
                      ]}>
                      <Select allowClear onChange={changeTypeData} showSearch>
                        <Option value='Open Travel Standard'>
                          Open Travel Standard
                        </Option>
                        <Option value='Lanyon Attraction Type'>
                          Lanyon Attraction Type
                        </Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label='Type'
                      name='type'
                      rules={[
                        {
                          required: true,
                          message: 'This field is required',
                        },
                      ]}>
                      <Select allowClear showSearch>
                        {typeData &&
                          typeData.map((item: any, i: any) => {
                            return (
                              <Option key={i} value={item.codeName}>
                                {item.codeName}
                              </Option>
                            )
                          })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label='Proximity'
                      name='proximity'
                      rules={[
                        {
                          required: true,
                          message: 'This field is required',
                        },
                      ]}>
                      <Select allowClear defaultValue='' showSearch>
                        {Object.values(PROXIMITY_OPTIONS).map(
                          (item: string, index: number) => (
                            <Option key={index} value={item}>
                              {item}
                            </Option>
                          ),
                        )}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item
                      name='typedetail'
                      label='Type Detail'
                      rules={[
                        {
                          max: 128,
                          message:
                            'You have reached the max character length of 128',
                        },
                      ]}>
                      <TextArea maxLength={128} />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={6}>
                    <Form.Item
                      label='Rank'
                      name='rank'
                      rules={[
                        {
                          pattern: /^\+?\d+$/,
                          message: 'This field should be a number',
                        },
                      ]}>
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label='Season'
                      name='season'
                      rules={[
                        {
                          max: 32,
                          message:
                            'You have reached the max character length of 32',
                        },
                      ]}>
                      <Select allowClear showSearch>
                        <Option value='Winter'>Winter</Option>
                        <Option value='Summer'>Summer</Option>
                        <Option value='YearRound'>YearRound</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      label='Guest Type'
                      name='guesttype'
                      rules={[
                        {
                          max: 32,
                          message:
                            'You have reached the max character length of 32',
                        },
                      ]}>
                      <Select allowClear showSearch>
                        <Option value='Family'>Family</Option>
                        <Option value='Adults'>Adults</Option>
                        <Option value='Teens'>Teens</Option>
                        <Option value='Children'>Children</Option>
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={24}>
                  <Col span={12}>
                    <Form.Item name='startAndEndDate' label='Start/End Date'>
                      <DatePicker.RangePicker format={dateFormat} />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item
                      name='crossstreet'
                      label='Cross Street Name'
                      rules={[
                        {
                          max: 128,
                          message:
                            'You have reached the max character length of 128',
                        },
                      ]}>
                      <Input maxLength={128} />
                    </Form.Item>
                  </Col>
                </Row>
                { isTagsDisplayed &&
                  <Row gutter={24} className={styles.pdBottom}>
                    <Col span={12}>
                      <Form.Item name='tags' label='Selected Tags'>
                        <Input
                          onChange={onSearchChange}
                          className={styles.tagsWidth}
                          suffix={
                            <Tooltip title='search'>
                              <SearchOutlined className={styles.colorOpt} />
                            </Tooltip>
                          }
                        />
                      </Form.Item>
                      <Transfer
                        dataSource={props.transferData}
                        targetKeys={transferTargetKeys}
                        onChange={handleChange}
                        render={(item) => item.codeName}
                      />
                    </Col>
                  </Row>
                }
              </Form>
            </div>
          </div>
          <ActionButtonsBar
            onDelete={DeleteClick}
            onCancel={() => props.setCurrentFlag('view')}
            onSave={SaveClick}
            disabledSave={disabledStatus}
          />
        </Card>
      </PageContainer>
    )
    
}

export default AttractionDetailEdit;
